import refs from '../helpers/refs'

class CCountryCard {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)

    this.init()
  }

  init () {
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.m-country-card')
    .forEach(el => new CCountryCard(el))
})
